import React from "react";
import { inject, observer } from "mobx-react";
import ToolbarButton from "../Buttons/ToolbarButton";
import { ReactComponent as AlignIcon } from "../../svg/align.svg";
import { ReactComponent as DuplicateIcon } from "../../svg/copy-icon.svg";
import { ReactComponent as SnapEnabled } from "../../svg/snapping-enabled.svg";
import { ReactComponent as MaskIcon } from "../../svg/mask-icon.svg";
import { ReactComponent as TrashIcon } from "../../svg/delete-icon.svg";
import { ReactComponent as UndoIcon } from "../../svg/undo-icon.svg";
import { ReactComponent as CropIcon } from "../../svg/crop-icon.svg";
import { ReactComponent as Text } from "../../svg/text-icon.svg";
import { ReactComponent as RedoIcon } from "../../svg/redo-icon.svg";
import { ReactComponent as FiltersIcon } from "../../svg/image-icon.svg";
import { ReactComponent as LockedIcon } from "../../svg/locked.svg";
import { ReactComponent as UnlockedIcon } from "../../svg/unlocked.svg";
import { ReactComponent as CloseIcon } from "../../svg/close.svg";
import { ReactComponent as CheckIcon } from "../../svg/check-light.svg";
import { ReactComponent as AlignMenuIcon } from "../../svg/align-icon.svg";
import { ReactComponent as ShiftMenuIcon } from "../../svg/shift-menu-icon.svg";
import { ReactComponent as ColorIcon } from "../../svg/color.svg";
import { ReactComponent as ObjectGroupIcon } from "../../svg/group-icon.svg";
import { ReactComponent as ObjectUnGroupIcon } from "../../svg/ungroup-icon.svg";
import AlignMenu from "../Inputs/AlignMenu";
import ToolTip from "../Inputs/ToolTip";
import ShiftMenu from "../Inputs/ShiftMenu";

@inject("store", "workAreaStore", "historyStore", "sidebarStore", "elementStore") @observer
class Toolbar extends React.Component {
  
  constructor(props){
    super(props)
    this.state = { 
      pageBackground: null,
      tooltips: {
        shift: {
          display: false,
          text: 'Shift the layer forward or backwards'
        },
        lock: {
          display: false,
          text: 'Disable or enable the editing of any layer'
        },
        snap: {
          display: false,
          text: 'Enable or disable layer snapping'
        },
        align: {
          display: false,
          text: 'Select a layer and align it relative to the page'
        },
        ungroup: {
          display: false,
          text: 'Ungroup layers in an existing group'
        },
        group: {
          display: false,
          text: 'Select at least two layers and group them together'
        },
        copy: {
          display: false,
          text: 'Select and duplicate a layer'
        },
        del: {
          display: false,
          text: 'Select and delete a layer'
        }
      }
    }
  }

  isLayerSelected = () => {
    return !!this.props.workAreaStore.selectedLayer
  };

  isPageSelected = () => {
    return !!this.props.workAreaStore.activePage
  }

  getFillColor = condition => {
    return condition ? "#F4F7FF" : "#FFFFFF";
  };

  getStrokeColor = condition => {
    return condition ? "#222222" : "#AAAAAA";
  };

  getEnabledStrokeColor = condition => {
    return condition ? "#222222" : "#AAAAAA";
  };

  openColorPicker = (isPageBackground = false, editingColor = false) => {
    const { sidebarStore, workAreaStore } = this.props
    if(isPageBackground){
      workAreaStore.deselectAllLayers()
      sidebarStore.changeStatus("color-picker-page")
    }else if(editingColor){
      workAreaStore.setEditingColor(editingColor)
      sidebarStore.changeStatus('svg-color-picker')
    }else{
      sidebarStore.changeStatus("color-picker")
    }
  }

  deleteLayer = (disabled) => {
    if(disabled){
      return
    }
    const { workAreaStore, sidebarStore } = this.props
    const { pageIdx, layerIdx } = workAreaStore.findLayerIdx(workAreaStore.selectedLayer)
    let layer = null
    if(pageIdx > -1 && layerIdx > -1){
      layer = workAreaStore.pages[pageIdx].layers[layerIdx]
    }
    if(layer && layer.type === 'text'){
      sidebarStore.closeSidebarSlide()
    }
    this.props.workAreaStore.deleteLayerById(
      this.props.workAreaStore.selectedLayer,
      false
    );
  
    this.setTooltipDisplay('del', false)
  };
  
  toggleSnap = () => {
    this.props.workAreaStore.toggleSnap();
  };

  duplicateLayer = disabled => {
    if(disabled){
      return
    }
    this.props.workAreaStore.copyLayer(
      this.props.workAreaStore.selectedLayer,
      true
    )
    this.setTooltipDisplay('copy', false)
  }

  undo = () => {
    this.props.workAreaStore.undo()
  }
  redo = () => {
    this.props.workAreaStore.redo()
  }

  getSelectedLayerBackground = () => {
    const { workAreaStore } = this.props
    const defaultColor = '#ffffff'
    if(this.isPageSelected()){
      const activePage = workAreaStore.getPage(workAreaStore.activePage)
      if(activePage && activePage.background){
        return activePage.background
      }else{
        return defaultColor
      }
    }
    if(this.isLayerSelected()){
      const layer = workAreaStore.selectedLayer
      if(layer && layer.background){
        return layer.background
      }else{
        return defaultColor
      }
    }
    return defaultColor
  }

  setTooltipDisplay(name, status){
    const copy = {...this.state.tooltips}
    copy[name].display = status
    this.setState({
      tooltips: copy
    })
  }

  handleToolbarClick(e){
    const { className } = e.target
    this.props.store.closeAll()
    if(typeof(className) === 'string'){
      if(!className.includes('align')){
        this.props.workAreaStore.toggleAlign(false)
      }
      if(!className.includes('shift')){
        this.props.workAreaStore.toggleShift(false)
      }
    }
  }

  getSelectedElementFill = () => {
    if (this.isLayerSelected()) {
      const layer = this.props.workAreaStore.pages[0].layers.find(l => l.id === this.props.workAreaStore.selectedLayer)
      if(layer && layer.fillHex){
        return layer.fillHex
      }else{
        return "#ffffff"
      }
    }
    return "#ffffff"
  }

  showFill(strokeColor){
    const { workAreaStore } = this.props
    const layerId = workAreaStore.selectedLayer
    let show = false
    if(!layerId){
      return <div />
    }
    const layer = workAreaStore.getLayer(layerId)
    if(layer && layer.type === 'svgGroup'){
      const colorList = this.props.workAreaStore.getSVGGroupColors(layer)
      return (
        <div className='svg-color-list'>
          {
            colorList.map((c, idx) => {
              return (
                <ColorIcon
                  key={c.color + idx}
                  className='svg-color-icon'
                  onClick={() => this.openColorPicker(false, c.color)}
                  fill={c.color}
                />
              )
            })
          }

        <label 
          className="mb-0 ml-1" 
          style={{ color: strokeColor }}
          onClick={() => this.openColorPicker(false)}
        >
          Fill
        </label>
        </div>
      )
    }
    if(!layer){
      return undefined
    }
    show = layer.type === 'element' || layer.type === 'svg'
    if(show){
      return (
        <label 
          className="mb-0 ml-2 cursor-pointer" 
          style={{ color: strokeColor }}
          onClick={() => this.openColorPicker(false)}
        >
          <ColorIcon
            className='color-icon'
            onClick={() => this.openColorPicker(false)}
            fill={this.getSelectedElementFill()}
          /> Fill
        </label>
      )
    }
    return <div />
  }

  showBackground(pageStroke){
    const { workAreaStore } = this.props
    const { resizingPage } = workAreaStore
    const pageId = workAreaStore.activePage
    if(!pageId){
      return <div />
    }
    const page = workAreaStore.getPage(pageId)
    if(!page){
      return <div />
    }
    return (
      <>
        {
          resizingPage ? undefined : (
            <label
              className="mb-0 ml-2 cursor-pointer" 
              style={{ color: '#000', display: "inline-block" }}
              onClick={() => this.openColorPicker(this.props.workAreaStore.activePage)}
            >
              {
                page.backgroundUrl ? (
                  <div className='page-bg-icon'
                  >
                    <img className='page-bg-icon__content' src={page.backgroundUrl} />
                  </div>
                ) : (
                  <ColorIcon
                  className='color-icon'
                  fill={page.background}
                />
                )
              }
              Background
            </label>
          )
        }
        {
          page && page.backgroundUrl ? (
            <div 
              className='toolbar__crop-icon cursor-pointer'
            >
              <span 
                onClick={() => this.props.workAreaStore.toggleBackgroundCropper(pageId)}
                className=''>
                  {resizingPage ? <CheckIcon stroke={'#000'} style={{marginTop: '-1px'}} /> : <CropIcon stroke="#495057" style={{ marginBottom: '2px', width: '18px', height: '18px' }} />}
                  {resizingPage ? 'Apply' : 'Crop'}
              </span>
              {
                resizingPage ? (
                  <span onClick={() => this.props.workAreaStore.toggleBackgroundCropper(pageId, true)} className='discard'>
                    <CloseIcon style={{width: '17px', height: '17px', marginRight: '3px'}} stroke={"#000"} />
                    Discard
                  </span>
                ) : undefined
              }
            </div>
          )
          :
          undefined
        }
      </>
    )
  }

  groupLayers(disabled){
    if(disabled){
      return
    }
    const { workAreaStore } = this.props
    const layer = workAreaStore.getSelectedLayer()
    if(layer.type === 'group' && layer.layers.length > 1 && !layer.finalGroup){
      workAreaStore.createFinalGroup()
    }
    this.setTooltipDisplay('group', false)
  }

  ungroupLayers(disabled){
    if(disabled){
      return
    }
    this.props.workAreaStore.ungroupItems()
    this.setTooltipDisplay('ungroup', false)
  }

  toggleAlignmentMenu(disabled){
    if(disabled){
      return
    }
    this.props.workAreaStore.toggleAlign(!this.props.workAreaStore.alignOpen)
    this.props.workAreaStore.toggleShift(false)
    this.setTooltipDisplay('align', false)
  }

  handleMouseMove(){
    const { workAreaStore, layerStore } = this.props
    workAreaStore.handleBackgroundMoveMouse(0, 0, true)
    workAreaStore.handleBackgroundResizeMouseUp()
    workAreaStore.handleResizeBarMouseUp()
    workAreaStore.handleResizeMouseUp()
    workAreaStore.handleLayerMoveMouseUp()
  }

  openFilters(){
    const { sidebarStore } = this.props
    sidebarStore.changeStatus('filters')
  }

  openPageFilters(){
    this.props.sidebarStore.changeStatus('page-filters')
  }

  openTextEdit(){
    const { sidebarStore, workAreaStore } = this.props
    if(!sidebarStore.textStyleOpen){
      workAreaStore.setTextEditing(this.props.workAreaStore.selectedLayer, true)
      sidebarStore.closeSidebarSlide()
      sidebarStore.setTextStyleSlide(true)
    }
  }

  showFilters(type, photoType, page = false){
    const wl = ['sticker', 'gif']
    if(page){
      const p = this.props.workAreaStore.getPage(this.props.workAreaStore.activePage)
      if(!p || !p.backgroundUrl || this.props.workAreaStore.resizingPage){
        return <div />
      }
      return (
        <label className="mb-0 ml-2 cursor-pointer" onClick={this.openPageFilters.bind(this)}>
          {
            <FiltersIcon 
              style={{
                marginLeft: '3px',
                marginRight: '5px',
                border: '2px solid #0b54dc',
                borderRadius: '3px'
              }} 
            />
          }
          Effects
        </label>
      )
    }
    if(type && (type === 'photo' && !wl.includes(photoType))){
      return (
        <label className="mb-0 ml-2 cursor-pointer" onClick={this.openFilters.bind(this)}>
          {
            <FiltersIcon 
              style={{
                marginRight: '5px',
                border: '2px solid #0b54dc',
                borderRadius: '3px'
              }} 
            />
          }
          Image effects
        </label>
      )
    }
  }

  showTextEdit(show){
    if(show){
      return (
        <label className='mb-0 ml-2 cursor-pointer' onClick={this.openTextEdit.bind(this)}>
          {
            <Text
              style={{
                marginRight: '5px',
                border: '2px solid #0b54dc',
                borderRadius: '3px'
              }}
            />
          }
          Text styling
        </label>
      )
    }
  }

  getTooltip(name, display, className){
    if(!display){
      return <></>
    }
    return (
      <ToolTip
        value={this.state.tooltips[name].text}
        className={className}
      />
    )
  }
  moreToRedo() {
    if (this.props.historyStore.history.length <= 1) {
      return false
    } else if (this.props.historyStore.history.length - 1 === this.props.historyStore.historyIndex) {
      return false
    }
    return true
  }
  moreToUndo() {
    if (this.props.historyStore.history.length <= 1) {
      return false
    } else if (0 === this.props.historyStore.historyIndex) {
      return false
    }
    return true
  }

  toggleLock(){
    const { workAreaStore } = this.props
    if(workAreaStore.selectedLayer){
      workAreaStore.toggleLayerLock(workAreaStore.selectedLayer)
    }
  }

  getSidebarWidth(){
    const sb = document.querySelector('.sidebar')
    if(sb){
      return sb.clientWidth
    }
  }

  toggleShiftMenu(disabled){
    if(disabled){
      return
    }
    let val = true
    if(this.props.workAreaStore.shiftOpen){
      val = false
    }
    this.props.workAreaStore.toggleShift(val)
    this.props.workAreaStore.toggleAlign(false)
    this.setTooltipDisplay('shift', false)
  }

  render() {
    const strokeColor = this.getStrokeColor(this.isLayerSelected());
    const fillColor = this.getFillColor(this.isLayerSelected());
    // disabled if no layer selected
    const isDisabledLayer = !this.isLayerSelected()
    const { workAreaStore, workAreaStore: { alignOpen, containerScroll, pageCenter, resizingPage, shiftOpen } } = this.props
    let isGroup = false
    let isFinal = false
    let isText = false
    let photoType = null
    let type = null
    let activeLayer = null
    if(workAreaStore.selectedLayer){
      const layer = workAreaStore.getSelectedLayer()
      if(!layer){
        isGroup = false
        isFinal = false
      }
      activeLayer = layer
      if(layer && layer.type === 'group'){
        isGroup = true
      }
      if(layer && layer.type === 'group' && layer.finalGroup){
        isFinal = true
      }
      isText = layer && layer.type === 'text'
      photoType = layer && layer.photoType
      type = layer && layer.type
    }
    const { open, textStyleOpen } = this.props.sidebarStore
    const hideGroup = isGroup && isFinal
    //const groupStroke = this.getStrokeColor(isGroup && !isFinal)
    //const ungroupStroke = this.getStrokeColor(isGroup && isFinal)
    const className = workAreaStore.hidden ? 'toolbar hidden' : `toolbar border-bottom ${open || textStyleOpen ? 'open-sidebar' : 'closed-sidebar'}`
    const { tooltips: { copy, del, group, ungroup, snap, shift, align, lock } } = this.state
    const sbWidth = this.getSidebarWidth()
    let toolbarStyle = {
      top: '56px',
      width: `calc(100% - ${open ? 420 : 94}px)`,
      marginLeft: open ? 420 : 94 + 'px',
      background: '#fff',
    }
    /*
    if(containerScroll > 0){
      let leftMargin = 94
      if(open){
        leftMargin = 420
      }
      let left = (open ? 420 : 94) - containerScroll
      if(left < 0){
        left = 0
      }
      if(open){
        left = 420
      }
      toolbarStyle = {
        ...toolbarStyle,
        width: `calc(100% - ${left}px)`,
        marginLeft: left + 'px'
      }
    }
    */
    return (
      <div className={className} 
        draggable={false}
        style={toolbarStyle}
        onDragEnter={e => { workAreaStore.hideUpload(); e.preventDefault(); return false; }}
        onDragCapture={e => { workAreaStore.hideUpload(); e.preventDefault(); return false; }}
        onDrag={e => { workAreaStore.hideUpload(); e.preventDefault(); return false; }}
        onDragEnd={e => { workAreaStore.hideUpload(); e.preventDefault(); return false; }}
        onClick={e => this.handleToolbarClick(e)}
        onMouseMove={() => this.handleMouseMove()}
      >
        <span className='color-options'>
          {this.showFill(strokeColor)}
          {this.showBackground(strokeColor)}
          {this.showFilters(type, photoType, !!workAreaStore.activePage)}
          {this.showTextEdit(isText)}
        </span>
        <span className="toolbar-center-element">
          <ToolbarButton
            clickAction={this.undo}
            disabled={this.props.historyStore.history.length <= 1}>
            <UndoIcon
              stroke={this.getStrokeColor(this.moreToUndo())}
              fill={this.getFillColor(this.moreToUndo())} />
          </ToolbarButton>
          <ToolbarButton
            clickAction={this.redo}
            disabled={this.props.historyStore.history.length <= 1}>
            <RedoIcon
              stroke={this.getStrokeColor(this.moreToRedo())}
              fill={this.getFillColor(this.moreToRedo())}
            />
          </ToolbarButton>
        </span>
        <span className="toolbar-btn-group">
          <ToolbarButton 
            onMouseOver={() => this.setTooltipDisplay('shift', true && !shiftOpen)}
            onMouseLeave={() => this.setTooltipDisplay('shift', false)}
          >
            <ShiftMenuIcon 
              className='shift-btn' 
              stroke={strokeColor} 
              fill={fillColor}
              onClick={() => this.toggleShiftMenu(isDisabledLayer)}
            />
            {
              shiftOpen ? (
                <ShiftMenu />
              )
              :
              undefined
            }
          </ToolbarButton>
          {
            this.getTooltip('shift', shift.display, 'shift-tip')
          }
          <ToolbarButton onClick={() => this.toggleLock()}>
            {
            activeLayer && activeLayer.locked ? 
              <LockedIcon
                stroke={activeLayer ? '#222222' : '#AAAAAA'} 
                className='lock-icon' 
                onMouseOver={() => this.setTooltipDisplay('lock', true)}
                onMouseLeave={() => this.setTooltipDisplay('lock', false)}
              />
              :
              <UnlockedIcon
                stroke={activeLayer ? '#222222' : '#AAAAAA'} 
                className='lock-icon' 
                onMouseOver={() => this.setTooltipDisplay('lock', true)}
                onMouseLeave={() => this.setTooltipDisplay('lock', false)}
              />
            }
          </ToolbarButton>
          {
            this.getTooltip('lock', lock.display, 'lock-tip')
          }
          <ToolbarButton onClick={this.toggleSnap}>
            <SnapEnabled
              stroke={this.props.workAreaStore.snapEnabled ? '#222222' : '#AAAAAA'} 
              className='snap-icon' 
              onMouseOver={() => this.setTooltipDisplay('snap', true)}
              onMouseLeave={() => this.setTooltipDisplay('snap', false)}
            />
          </ToolbarButton>
          {
            this.getTooltip('snap', snap.display, 'snap-tip')
          }
          <ToolbarButton
            onMouseOver={() => this.setTooltipDisplay('align', true && !alignOpen)}
            onMouseLeave={() => this.setTooltipDisplay('align', false)}
          >
            <AlignMenuIcon className='align-btn' stroke={strokeColor} fill={fillColor} onClick={() => this.toggleAlignmentMenu(isDisabledLayer)} />
            {
              alignOpen ? (
                <AlignMenu />
              )
              :
              undefined
            }
          </ToolbarButton>
          {
            this.getTooltip('align', align.display, 'align-tip')
          }
          {
            !hideGroup ? (
              <>
              <ToolbarButton 
                onClick={() => this.groupLayers()}
                onMouseEnter={() => this.setTooltipDisplay('group', true)}
                onMouseLeave={() => this.setTooltipDisplay('group', false)}
              >
                <ObjectGroupIcon stroke={strokeColor} fill={fillColor} onClick={() => this.groupLayers(!isGroup && isFinal)} className="fa-icon" />
              </ToolbarButton>
              {
                this.getTooltip('group', group.display, 'group-tip')
              }
              </>
            )
            :
            (
              <>
              <ToolbarButton
                onClick={() => this.ungroupLayers()}
                onMouseEnter={() => this.setTooltipDisplay('ungroup', true)}
                onMouseLeave={() => this.setTooltipDisplay('ungroup', false)}
              >
                <ObjectUnGroupIcon stroke={strokeColor} fill={fillColor} onClick={() => this.ungroupLayers(!isGroup && !isFinal)} className="fa-icon" />
              </ToolbarButton>
              {
                this.getTooltip('ungroup', ungroup.display, 'ungroup-tip')
              }
              </>
            )
          }
          <ToolbarButton 
            onMouseEnter={() => this.setTooltipDisplay('copy', true)}
            onMouseLeave={() => this.setTooltipDisplay('copy', false)}
            clickAction={() => this.duplicateLayer(isDisabledLayer)}
          >
            <DuplicateIcon stroke={strokeColor} fill={fillColor} />
          </ToolbarButton>
          {
            this.getTooltip('copy', copy.display, 'copy-tip')
          }
          <ToolbarButton 
            onMouseEnter={() => this.setTooltipDisplay('del', true)}
            onMouseLeave={() => this.setTooltipDisplay('del', false)}
            clickAction={() => this.deleteLayer(isDisabledLayer)}
          >
            <TrashIcon stroke={strokeColor} fill={fillColor} />
          </ToolbarButton>
          {
            this.getTooltip('del', del.display, 'delete-tip')
          }
        </span>
      </div>
    );
  }
}

export default Toolbar;
